import { createBrowserRouter, type RouteObject } from "react-router";

import { AdminShell } from "../layouts/AdminShell";
import { NotFound } from "../layouts/NotFound";

function page(load: () => Promise<{ default: React.ComponentType }>): Pick<RouteObject, "lazy"> {
  return { lazy: async () => ({ Component: (await load()).default }) };
}

export const routes: RouteObject[] = [
  {
    element: <AdminShell />,
    children: [
      { index: true, ...page(() => import("../features/OverviewPage")) },
      { path: "enquiries", ...page(() => import("../features/EnquiriesPage")) },
      { path: "organizations", ...page(() => import("../features/OrganizationsPage")) },
      { path: "organizations/:organizationId", ...page(() => import("../features/OrganizationPage")) },
      { path: "users", ...page(() => import("../features/UsersPage")) },
      { path: "users/:userId", ...page(() => import("../features/UserPage")) },
      { path: "plans", ...page(() => import("../features/PlansPage")) },
      { path: "starter-templates", ...page(() => import("../features/StarterTemplatesPage")) },
      { path: "analytics", ...page(() => import("../features/AnalyticsPage")) },
      { path: "deliverability", ...page(() => import("../features/DeliverabilityPage")) },
      { path: "risk", ...page(() => import("../features/RiskPage")) },
      { path: "messages", ...page(() => import("../features/MessagesPage")) },
      { path: "mail-queue", ...page(() => import("../features/MailQueuePage")) },
      { path: "suppressions", ...page(() => import("../features/SuppressionsPage")) },
      { path: "infrastructure", ...page(() => import("../features/InfrastructurePage")) },
      { path: "audit", ...page(() => import("../features/AuditPage")) },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export function createRouter() {
  return createBrowserRouter(routes);
}
